import { ApolloError } from '@apollo/client';
import { create } from '@thoughtspot/logger';
import { EventType } from '/@utils/embed.util';
import { dispatchNonMemoEvent } from '/@utils/event-bridge/event-bridge';
import { setAuthToken } from '/@utils/http-request-polyfill';

const logger = create('navigate-to-login-check.utils');

export const notifyOnSessionTimeout = () => {
    return dispatchNonMemoEvent(EventType.IdleSessionTimeout, {})
        .then(({ data }: any): any => {
            if (data.authToken) {
                setAuthToken(data.authToken);
            }
            return null;
        })
        .catch(error => {
            logger.error(error);
        });
};

export const notifyOnAuthExpiration = () => {
    return dispatchNonMemoEvent(EventType.AuthExpire, {})
        .then(({ data }: any): any => {
            if (data.authToken) {
                // setToken(data.authToken);
                setAuthToken(data.authToken);
            }
            return null;
        })
        .catch(error => {
            logger.error(error);
        });
};

export const getStatusCodeFromPrismError = (apolloError: ApolloError) => {
    const networkError: any = apolloError.networkError;

    if (networkError?.result?.errors) {
        const error = networkError.result.errors[0];
        const upstreamResponse = error?.extensions?.exception?.upstreamResponse;
        const status = upstreamResponse?.status;

        if (status) {
            return status;
        }
        return networkError.statusCode;
    }
    // if response does not return in JSON.
    if (networkError?.statusCode) return networkError.statusCode;

    return null;
};
